<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div style="overflow-x: auto">
    <v-container fluid>
      <v-data-table :headers="h" :items="contribuicoes" class="elevation-1">
        <template #top>
          <v-toolbar flat>
            <v-btn
              style="background: #f9f8f8; font-size: 18px"
              size="small"
              @click="this.$router.go(-1)"
              icon
            >
              <v-icon color="#004984">mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title style="font-size: 22px; font-weight: bold"
              >Contribuição Individual</v-toolbar-title
            >
            <v-divider class="mx-4" inset vertical></v-divider>
          </v-toolbar>
        </template>
        <template #no-data>
          <div class="text-center py-6">
            <span> Sem contribuições a listar </span>
          </div>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import { VDataTable } from 'vuetify/labs/VDataTable';

import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    VDataTable,
  },
  data: () => ({
    h: [],
    headers: [
      {
        title: 'Nomes',
        align: 'center',
        key: 'Nome',
        width: '250px',
      },
      { title: 'Velocity', align: 'center', key: 'Velocity', width: '250px' },
      { title: 'Tarefas', align: 'center', key: 'Tarefas', width: '250px' },
    ],
    contribuicoes: [],
    /* eslint-disable */
    editedItem: {
      Nome: '',
      Velocity: '',
      Tarefas: '',
    },
    defaultItem: {
      Nome: '',
      Velocity: '',
      Tarefas: '',
    },
    /* eslint-enable */
  }),

  created() {
    this.fetchContribution();
  },

  methods: {
    // Função de inicialização de usuários, sempre preenche com uma req ao back
    fetchContribution() {
      var keysTable = [];
      axios
        .get(API_URL + `/sprints/contribuicao/${this.$route.params.id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          response.data.forEach((element, index) => {
            if (index == 0) {
              this.h.push(
                {
                  title: element.Nome,
                  align: 'center',
                  key: 'Nome',
                  width: '250px',
                },
                {
                  title: element.Velocity,
                  align: 'center',
                  key: 'Velocity',
                  width: '250px',
                },
              );
              element.Tarefas.forEach((str) => {
                const obj = {
                  title: str,
                  align: 'center',
                  key: str,
                  width: '250px',
                };
                keysTable.push(str);
                this.h.push(obj);
              });
            } else {
              const jsonObjNomes = {
                Nome: element.Nome,
                Velocity: element.Velocity,
              };
              const jsonObjTarefas = {};
              element.Tarefas.forEach((pontos, index) => {
                jsonObjTarefas[keysTable[index]] = pontos;
              });
              const jsonFinal = Object.assign({}, jsonObjNomes, jsonObjTarefas);
              this.contribuicoes.push(jsonFinal);
            }
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.v-data-table {
  overflow-x: auto;
}
</style>
